module.exports = __webpack_public_path__ + "img/e_3_17_r.016f80e3.png";